// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__I8Myp","description":"PatientConsentPreview_description__23r56"};